<section class="hero wave-bg">
  <div class="container hero-content">
    <h1>
      Expertise TMA Android : 
      <span class="accent">Maintenance Corrective & Évolutive pour Apps Android</span>
    </h1>
    <p class="hero-description">
      Votre application Android souffre de crashs (ANR), de lenteurs ou d'une dette technique accumulée ? Nos experts seniors certifiés Kotlin et Java interviennent pour stabiliser vos outils mobiles et garantir une expérience utilisateur irréprochable.
    </p>
    <div class="cta-row">
      <a
        href="https://cal.mesh-box.fr/ogirodin/30min"
        class="button primary large"
        data-cal-link="ogirodin/30min"
        data-cal-config='{"layout":"month_view"}'
      >
        Diagnostic Technique Android
      </a>
    </div>
  </div>
</section>

<section class="section alt">
  <div class="container max-w-4xl">
    <h2>Pourquoi une Tierce Maintenance Applicative dédiée à Android ?</h2>
    <p class="mb-6">
      L'écosystème mobile Android se caractérise par une forte fragmentation matérielle et logicielle. Assurer le bon fonctionnement d'une application sur des milliers de modèles différents nécessite une expertise spécifique en gestion de la mémoire, optimisation de la batterie et compatibilité ascendante. Un crash en production n'est pas seulement un problème technique, c'est une perte directe d'utilisateurs et une dégradation de l'image de votre marque sur le Play Store.
    </p>
    <h3>Garantir la stabilité et la rétention utilisateur</h3>
    <p class="mb-6">
      Chez Mesh Box, nous nous concentrons sur les indicateurs de santé critiques de votre application. Nous utilisons des outils d'observabilité avancés comme Firebase Crashlytics pour identifier et corriger les "edge cases" avant qu'ils n'impactent massivement votre base d'utilisateurs. Notre objectif est de maintenir un taux de session sans crash supérieur à 99.5%.
    </p>
  </div>
</section>

<section class="section">
  <div class="container">
    <h2>Nos Domaines d'Intervention Mobile Expert</h2>
    <div class="grid-2">
      <div class="card">
        <div class="card-icon">💥</div>
        <h3>Élimination des ANR & Crashs</h3>
        <p>Analyse approfondie des stacks traces pour éradiquer les "Application Not Responding" (ANR) et les plantages inattendus. Nous stabilisons votre code Kotlin ou Java legacy.</p>
      </div>
      <div class="card">
        <div class="card-icon">🔒</div>
        <h3>Sécurité & Conformité Play Store</h3>
        <p>Audit des vulnérabilités mobiles et mise en conformité avec les directives de Google (Target SDK, API levels). Nous gérons la publication et le suivi des releases sur la console.</p>
      </div>
      <div class="card">
        <div class="card-icon">🚀</div>
        <h3>Optimisation des Performances</h3>
        <p>Réduction du temps de chargement initial (Cold Start), optimisation de la gestion du réseau (Retrofit) et de la persistance des données locale (Room) pour une fluidité maximale.</p>
      </div>
      <div class="card">
        <div class="card-icon">📱</div>
        <h3>Modernisation UI/UX</h3>
        <p>Migration progressive vers Jetpack Compose pour des interfaces modernes et performantes. Nous assurons que votre Design System est respecté sur tous les formats d'écran.</p>
      </div>
    </div>
  </div>
</section>

<section class="section alt">
  <div class="container max-w-4xl">
    <h2>Une méthodologie de maintenance mobile proactive</h2>
    <p class="mb-8">
      La TMA mobile exige une réactivité immédiate face aux retours utilisateurs et aux mises à jour système d'Android. Nous mettons en place un workflow de développement sécurisé incluant des tests unitaires et des tests sur terminaux réels via Firebase Test Lab.
    </p>
     <div class="grid-2 gap-8 mb-10">
      <div class="flex items-start gap-3">
        <span class="text-brand font-bold text-xl">✓</span>
        <div>
          <h4 class="font-bold">Hotfixes en urgence</h4>
          <p class="text-sm">Déploiement de correctifs prioritaires en moins de 72h pour les bugs bloquants.</p>
        </div>
      </div>
      <div class="flex items-start gap-3">
        <span class="text-brand font-bold text-xl">✓</span>
        <div>
          <h4 class="font-bold">Gestion des versions Target SDK</h4>
          <p class="text-sm">Anticipation des exigences annuelles de Google pour éviter tout déréférencement de votre application.</p>
        </div>
      </div>
      <div class="flex items-start gap-3">
        <span class="text-brand font-bold text-xl">✓</span>
        <div>
          <h4 class="font-bold">Tableaux de bord mensuels</h4>
          <p class="text-sm">Rapports détaillés sur le taux de crash, les notes Play Store et les performances techniques.</p>
        </div>
      </div>
      <div class="flex items-start gap-3">
        <span class="text-brand font-bold text-xl">🏛️</span>
        <div>
          <h4 class="font-bold">Agréé Crédit Impôt Innovation</h4>
          <p class="text-sm">Vos dépenses de maintenance évolutive mobile sont éligibles au CII (Crédit Impôt Innovation).</p>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="section">
  <div class="container max-w-4xl">
    <h2>Maîtrise de la stack technologique Android</h2>
    <p class="mb-8">Nos experts mobiles maîtrisent l'intégralité de l'écosystème pour garantir une maintenance efficace quel que soit l'historique de votre projet.</p>
    <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); gap: 1.5rem;">
      <div class="p-4 bg-alt rounded-lg">
        <h4 class="font-bold mb-2">Développement</h4>
        <ul class="text-xs space-y-1 opacity-80">
          <li>Kotlin / Coroutines</li>
          <li>Jetpack Compose / XML</li>
          <li>Android KTX</li>
        </ul>
      </div>
      <div class="p-4 bg-alt rounded-lg">
        <h4 class="font-bold mb-2">Architecture</h4>
        <ul class="text-xs space-y-1 opacity-80">
          <li>MVVM / Clean Architecture</li>
          <li>Dependency Injection (Hilt)</li>
          <li>Room Persistence</li>
        </ul>
      </div>
      <div class="p-4 bg-alt rounded-lg">
        <h4 class="font-bold mb-2">Réseau & Services</h4>
        <ul class="text-xs space-y-1 opacity-80">
          <li>Retrofit / OkHttp</li>
          <li>Firebase Ecosystem</li>
          <li>REST / GraphQL</li>
        </ul>
      </div>
      <div class="p-4 bg-alt rounded-lg">
        <h4 class="font-bold mb-2">Qualité & CI/CD</h4>
        <ul class="text-xs space-y-1 opacity-80">
          <li>GitHub Actions</li>
          <li>Bitrise / Fastlane</li>
          <li>JUnit / Espresso</li>
        </ul>
      </div>
    </div>
    <div class="mt-8 text-center text-sm text-muted">
      Pour consulter les guides officiels, visitez <a href="https://developer.android.com/" target="_blank" rel="noopener noreferrer" class="underline">Android Developers</a>.
    </div>
  </div>
</section>

<section class="section alt">
  <div class="container max-w-4xl text-center">
    <h2>Une approche Full-Stack pour votre projet</h2>
    <p class="mb-8">Une application mobile performante dépend souvent d'un backend robuste et d'un frontend web cohérent.</p>
    <div class="flex justify-center gap-6 flex-wrap">
      <a routerLink="/tma-nodejs" class="button outline">Expertise TMA Node.js</a>
      <a routerLink="/tma-angular" class="button outline">Expertise TMA Angular</a>
      <a routerLink="/refonte-modernisation-legacy" class="button outline">Modernisation Legacy</a>
    </div>
  </div>
</section>

<section class="section cta-final">
  <div class="container">
    <div style="max-width: 700px; margin: 0 auto; text-align: center;">
      <h2 style="margin-bottom: 1rem;">Offrez à vos utilisateurs l'excellence mobile</h2>
      <p style="margin-bottom: 2rem; font-size: 1.1rem;">
        Ne laissez plus la dette technique freiner votre présence mobile. Bénéficiez d'un <strong>diagnostic gratuit de 30 min</strong> avec l'un de nos experts seniors.
      </p>
      <a
        href="https://cal.mesh-box.fr/ogirodin/30min"
        class="button primary large"
        data-cal-link="ogirodin/30min"
      >
        Réserver mon Audit Android
      </a>
      <br />
      <a routerLink="/maintenance-tma-nodejs-angular" style="display: inline-block; margin-top: 1.5rem; color: var(--brand); font-weight: bold;">
        ← Voir toutes nos offres de maintenance
      </a>
    </div>
  </div>
</section>
